/**
 * FinishedCourseMessage Component
 *
 * Features:
 * - Displays a congratulatory message when the user finishes a course.
 * - Shows user name and diploma instructions.
 * - Uses Redux for user info and CSS modules for styling.
 */
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import classes from './FinishedCourseMessage.module.css';

const FinishedCourseMessage = () => {
  const dataUser = useSelector(state => state.userInfo);

  return (
    <div className={classes.finishedCourseContainer}>
      <p className={classes.title}>
        {/* User's name from Redux */}
        ¡Felicidades, {dataUser.data.nombre}!
      </p>
      <p className={classes.subtitle}>
        Completaste con éxito tu curso
      </p>
      <p className={classes.complementaryInfo}>
        Recuerda: si tu curso entrega diploma, podrás encontrarlo en
        Mis Diplomas
      </p>
      {/* Props passed to Button:
          - className: classes.btnDegree
          - component: "a"
          - href: diploma portfolio URL
      */}
      <Button
        className={classes.btnDegree}
        component="a"
        href={`${process.env.REACT_APP_API_PATH_GENERAL_CAMPUS}/myPortfolio`}
      >
        Ir a Mis Diplomas
      </Button>
    </div>
  );
};

export default FinishedCourseMessage;
